import React from 'react';
import { LatestContentItem } from '../../features/content/types';

interface ContentCardProps {
  content: LatestContentItem;
  onClick?: (contentId: string) => void;
  className?: string;
  style?: React.CSSProperties;
}

const ContentCard: React.FC<ContentCardProps> = ({ 
  content, 
  onClick, 
  className = "w-full h-full relative rounded-[4px] overflow-hidden",
  style 
}) => {
  const imageUrl = content.media_conversions?.medium || content.media_conversions?.small || content.download_url;
  
  const handleClick = () => {
    if (onClick) {
      onClick(content.id);
    }
  };
  
  return (
    <div 
      className={`${className} ${onClick ? 'cursor-pointer' : ''}`}
      onClick={handleClick}
      style={style}
    >
      <img 
        src={imageUrl} 
        alt={content.file_name || 'Content'} 
        className="w-full h-full object-cover block"
      />
    </div>
  );
};

export default ContentCard; 